import React from 'react';
import { TProductBuildAndPriceLinkProps } from './types/buildAndPriceLink.types';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import { BuildAndPriceLinkModel } from './models/buildAndPriceLink.model';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';

const ProductBuildAndPriceLink = (props: TProductBuildAndPriceLinkProps) => {
    const model = new BuildAndPriceLinkModel(props);
    const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

    // Component is unreleased
    if (model.isUnreleased) {
        return <UnreleasedComponent />;
    }

    //  star node opened directly in EE
    if (isPlaceholderShown) {
        return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
    }

    return null;
}

export default ProductBuildAndPriceLink;
